module.exports = __webpack_public_path__ + "static/media/ui.c5483f0d.png";